import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=78326143&"
import script from "./MainTitle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MainTitle.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=78326143&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports